// React Basic and Bootstrap
import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

//Import Components
import SectionTitle from "../../components/Shared/section-title";
import PricingBox2 from "../../components/Shared/pricing-box2";

import integrations from '../../images/basic_Integration.png';

class Pricing extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <section className="section" id="integrations">
                    <Container>
                        {/* section title */}
                        <SectionTitle title="Integraciones" desc="" />

                        <Row className="align-items-center">
                            {/* pricing */}
                            {/* <PricingBox2 pricings={this.state.pricings} /> */}

                            <Col md={{size:6, order:1}} xs={{order:2}} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                                <div className="section-title mr-lg-5">
                                    {/* <h4 className="title mb-4">Entregamos autoservicio para tus colaboradores</h4> */}
                                    <p className="text-muted">Rindo se integra con el software de tu empresa. Tenemos integración nativa y Single Sign-On con SAP SuccessFactors. Consideramos las integraciones un factor importante en la transormación digital de tu organización ya que un sistema integrado significa un equipo organizado y productivo.</p>
                                    {/* <Link to="#" className="btn btn-outline-primary">Start Now <i className="mdi mdi-chevron-right"></i></Link> */}
                                </div>
                            </Col>
                            
                            <Col md={{size:6, order:1}} xs={{order:1}}>
                                <img src={integrations} className="img-fluid" alt="" />
                            </Col>
                        </Row>
                    </Container>
                </section>
            </React.Fragment>
        );
    }
}
export default Pricing;
